export { default, getServerSideProps } from '../../../src/pages/expertDirectory/industries';
